import Vue from "vue";
import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import {
  ICategoryCreateRequest,
  ICategoryListRequest,
  ICategoryUpdateRequest,
  CategoryState,
  ICategory
} from "@/types/category";
import axios from "axios";

export const actions: ActionTree<CategoryState, RootState> = {
  async getList({ commit }, params: ICategoryListRequest) {
    try {
      const response = await axios.get<IPagination<ICategory[]>>("/category", {
        params
      });

      commit("pagination", response.data);
      commit("error/resetError", null, { root: true });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },
  async get({ commit }, category_id: number) {
    try {
      const response = await axios.get<ICategory>(`/category/${category_id}`);

      commit("single", response.data);
      commit("error/resetError", null, { root: true });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },
  async adminGetList({ commit }, params: ICategoryListRequest) {
    try {
      const response = await axios.get<IPagination<ICategory[]>>(
        "/admin/category",
        {
          params
        }
      );

      commit("pagination", response.data);
      commit("error/resetError", null, { root: true });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },
  async adminGet({ commit }, category_id: number) {
    try {
      const response = await axios.get<ICategory>(
        `/admin/category/${category_id}`
      );

      commit("single", response.data);
      commit("error/resetError", null, { root: true });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },
  async adminUpdate(
    { commit },
    data: { category_id: number; params: ICategoryUpdateRequest }
  ) {
    try {
      const response = await axios.patch<ICategory>(
        `/admin/category/${data.category_id}`,
        data.params
      );

      commit("single", response.data);
      commit("error/resetError", null, { root: true });
      Vue.prototype.$flashStorage.flash("更新完了", "success", {
        timeout: 3000,
        important: true
      });
      return true;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
      Vue.prototype.$flashStorage.flash(
        "更新失敗:入力内容を確認してください",
        "error",
        { timeout: 3000, important: true }
      );
      return false;
    }
  },
  async adminCreate({ commit }, params: ICategoryCreateRequest) {
    try {
      const response = await axios.post<ICategory>(`/admin/category`, params);

      commit("single", response.data);
      commit("error/resetError", null, { root: true });
      Vue.prototype.$flashStorage.flash("作成完了", "success", {
        timeout: 3000,
        important: true
      });
      return true;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
      Vue.prototype.$flashStorage.flash(
        "作成失敗:入力内容を確認してください",
        "error",
        { timeout: 3000, important: true }
      );
      return false;
    }
  },
  async adminDelete({ commit }, category_id: number) {
    try {
      await axios.delete(`/admin/category/${category_id}`);
      Vue.prototype.$flashStorage.flash("削除完了", "success", {
        timeout: 3000,
        important: true
      });
      commit("error/resetError", null, { root: true });
      return true;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
      Vue.prototype.$flashStorage.flash("削除失敗", "error", {
        timeout: 3000,
        important: true
      });

      return false;
    }
  },
  async adminIsDeletable({ commit }, category_id: number) {
    try {
      const response = await axios.get<boolean>(
        `/admin/category/${category_id}/isdeletable`
      );
      commit("canDelete", response.data);
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  }
};

export default actions;
